<template>
  <div>
    <router-view v-show='this.$route.matched.length==3'></router-view>
    <PageHeaderLayout v-show='this.$route.matched.length==2'>
      <div class='main-page-content'>
        <div style='min-height: calc(100vh - 100px);'>
          <div>
            <el-form :inline='true' ref='form'>
              <el-form-item>
                <el-date-picker
                  v-model='searchCondition.rangYm'
                  type='monthrange'
                  unlink-panels
                  range-separator='至'
                  start-placeholder='开始月份'
                  end-placeholder='结束月份'
                  value-format='yyyy-MM'
                  format='yyyy年MM月'
                  :picker-options='pickerOptions'
                  @change='handleQuery'
                  style='width: 240px'>
                </el-date-picker>
              </el-form-item>
              <el-form-item>
                <el-input v-model='searchCondition.nickname' placeholder='昵称' clearable></el-input>
              </el-form-item>
              <el-form-item>
                <el-select multiple collapse-tags v-model='searchCondition.msg_status' style='width: 140px' clearable
                           placeholder='通知状态'>
                  <el-option :label='option.text' :value='option.value' v-for='(option) in msgStataMap'
                             :key='`msg_status_${option.value}`'></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-select multiple collapse-tags v-model='searchCondition.audit' placeholder='确认状态'
                           style='width: 140px' clearable>
                  <el-option v-for='(option) in statusAuditSet' :value='option.value' :label='option.text'
                             :key='option.value'></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-select v-model='searchCondition.settle_method' style='width: 120px' placeholder='结算方式'
                           clearable>
                  <el-option v-for='(label,value) in optionMaps["settle_method"]' :value='value' :label='label'
                             :key='value'></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-select v-model='searchCondition.invoice_type' style='width: 100px' placeholder='发票类型' clearable>
                  <el-option v-for='(label,value) in optionMaps["invoice_type"]' :value='value' :label='label'
                             :key='value'></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-select v-model='searchCondition.need_invoice' style='width: 100px' placeholder='是否开票' clearable>
                  <el-option label='是' value='Y'></el-option>
                  <el-option label='否' value='N'></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-select v-model='searchCondition.status' style='width: 100px' clearable
                           placeholder='状态'>
                  <el-option :label='option.text' :value='option.value' v-for='(option) in statusMap'
                             :key='`status_${option.value}`'></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-select v-model='searchCondition.letter_status' placeholder='分成函状态'
                           style='width: 110px' clearable>
                  <el-option v-for='(option) in letterStatusRange' :value='option' :label='option'
                             :key='option'></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button @click='handleQuery' icon='el-icon-search' type='primary' :loading='loading'
                           :disabled='loading'>查询
                </el-button>
              </el-form-item>
              <el-form-item>
                <el-button icon='el-icon-upload' @click='openImport=true'
                           v-if="userPermissions.indexOf('artist_divide_import') !== -1">分成导入
                </el-button>
                <!--                <el-button icon='el-icon-upload' @click='openImportOrders=true'-->
                <!--                           v-if="userPermissions.indexOf('artist_order_import') !== -1">订单导入-->
                <!--                </el-button>-->
              </el-form-item>
              <el-form-item v-if='userPermissions.indexOf("artist_divide_lock_unlock")>-1'>
                <el-button-group v-if='extra.lock_status!=="unknown"'>
                  <el-button type='primary' icon='el-icon-lock' @click='handleLock' v-if='extra.lock_status==="N"'>
                    锁定
                  </el-button>
                  <el-button type='warning' icon='el-icon-unlock' @click='handleUnlock' v-if='extra.lock_status==="Y"'>
                    解锁
                  </el-button>
                </el-button-group>

              </el-form-item>
              <el-form-item style='float: right;'>
                <el-button title='折叠或展开更多操作项' type='text'
                           :icon='!showMore?"el-icon-caret-bottom":"el-icon-caret-top"'
                           @click='showMore=!showMore'>
                  {{ !showMore ? '' : '' }}
                </el-button>
              </el-form-item>
              <el-form-item style='float: right;' label-width='1px'>
                <el-button icon='el-icon-refresh' @click='handleSync' type='primary'
                           v-if="userPermissions.indexOf('artist_divide_sync') !== -1">初始化
                </el-button>
                <el-button icon='el-icon-plus' @click='handleAdd' type='success'
                           v-if="userPermissions.indexOf('artist_divide_save') !== -1">新增
                </el-button>
              </el-form-item>

            </el-form>

            <div class='default-panel theme-border mb8'
                 style='padding: 4px;display: flex;flex-direction: row;justify-content: flex-start;gap: 5px;'
                 v-if='showMore'>
              <!--              <el-button icon='el-icon-upload' @click='openImport=true'-->
              <!--                         v-if="userPermissions.indexOf('artist_divide_import') !== -1">分成导入-->
              <!--              </el-button>-->
              <!--              <el-button icon='el-icon-upload' @click='openImportOrders=true'-->
              <!--                         v-if="userPermissions.indexOf('artist_order_import') !== -1">订单导入-->
              <!--              </el-button>-->
              <!--              <el-button icon='el-icon-refresh' @click='handleSync' type='primary'-->
              <!--                         v-if="userPermissions.indexOf('artist_divide_import') !== -1">初始化-->
              <!--              </el-button>-->
              <!--              <el-button icon='el-icon-plus' @click='handleAdd' type='success'-->
              <!--                         v-if="userPermissions.indexOf('artist_divide_save') !== -1">新增-->
              <!--              </el-button>-->
              <!--              <el-button icon='el-icon-position' @click='handleSync' type='warning'-->
              <!--                         v-if="userPermissions.indexOf('artist_divide_import') !== -1">通知-->
              <!--              </el-button>-->
              <el-button icon='el-icon-s-promotion' v-if='hasAuthority("artist_divide_notify")'
                         @click='handleBatchNotify' type='primary'
                         :disabled='ids.length===0'>
                通知确认分成信息
              </el-button>

              <export-btn ref='refLogisticSubscribeExport'
                          :can-export='hasAuthority("artist_divide_export")'
                          @export='handleExport'></export-btn>

              <el-button icon='el-icon-delete' v-if='hasAuthority("artist_divide_save") && extra.lock_status==="N"'
                         @click='handleBatchDelete'
                         type='danger'
                         :disabled='ids.length===0' plain>
                删除
              </el-button>
              <el-button icon='el-icon-refresh-left' v-if='hasAuthority("artist_divide_reset_status")'
                         @click='handleBatchReset'
                         type='warning'
                         :disabled='ids.length===0' plain>
                重置状态
              </el-button>
              <!--              <el-button type='primary' icon='el-icon-data-analysis'>统计</el-button>-->
              <!--              <el-button type='primary' icon='el-icon-pie-chart'>统计</el-button>-->
            </div>
          </div>

          <div class='default-table'>

            <el-table
              :border='true'
              :data='tableData'
              :header-cell-style='headClass'
              @selection-change='handleSelectionChange'
              @sort-change='changeTableSort'
              ref='multipleTable'
              row-key='id'
              style='width: 100%'
              tooltip-effect='dark'
              @row-dblclick='handleRowClick'
              highlight-current-row
              stripe
              show-summary
              :summary-method='getSummaries'
            >
              <el-table-column
                :reserve-selection='true'
                key='selectable'
                type='selection'
                fixed='left'
                width='40'>
              </el-table-column>
              <el-table-column
                align='center'
                label='序号'
                width='50'
                fixed='left'
              >
                <template slot-scope='scope'>
                  <span>{{ tablePagination.offset + scope.$index + 1 }}</span>
                </template>
              </el-table-column>
              <el-table-column
                align='center'
                label='月份'
                min-width='100'
                prop='date_time'
                sortable='custom'
                fixed='left'
              >
                <template slot-scope='{row}'>
                  <span>{{ dateFormat(row.date_time, '{y}年{m}月') }}</span>
                </template>
              </el-table-column>
              <el-table-column align='center' label='红人昵称' min-width='120' prop='nickname'
                               show-overflow-tooltip
                               sortable='custom'
                               fixed='left'
              >
                <template slot-scope='{row}'>
                  {{ row.nickname || '--' }}
                  <!--                  <artist-nickname :info='{artist_id:row.artist_id,nickname:row.nickname}' />-->
                </template>
              </el-table-column>
              <el-table-column align='center' label='经纪人'
                               min-width='120'
                               prop='agent_name'
                               show-overflow-tooltip
                               sortable='custom'
              >
                <template slot-scope='{row}'>

                  <div class='flex-sb'>
                    <div> {{ row.agent_name || '--' }}</div>

                    <el-button @click='handleNotify(row)' size='medium'
                               :style="`color: ${row.msg_status===1?'#409EFF':'#0ce537'}`"
                               type='text'><i
                                 class='el-icon-chat-line-square'></i>
                    </el-button>
                    <!--                    <el-tooltip :content="`【通知】『${row.nickname}』的经纪人，确认分成信息`" placement="right" effect="light">-->
                    <!--                      <el-link style='color: #1e83e9' v-if='row.msg_status==1' icon='el-icon-position'>通知</el-link>-->
                    <!--                    </el-tooltip>-->
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                align='center'
                label='支付对象'
                min-width='110'
                prop='payment_target'
                show-overflow-tooltip
              >
                <template slot-scope='{row}'>
                  {{ row.payment_target || '--' }}
                </template>
              </el-table-column>
              <el-table-column
                align='right'
                label='卖货分成'
                prop='commerce_pay'
                sortable='custom'
                width='110'
              >
                <template slot-scope={row}>
                  <span>{{ moneyFormat(row.commerce_pay) }}</span>
                </template>
              </el-table-column>
              <el-table-column
                align='right'
                label='推广分成'
                prop='publicity_pay'
                sortable='custom'
                width='110'
              >
                <template slot-scope={row}>
                  <span>{{ moneyFormat(row.publicity_pay) }}</span>
                </template>
              </el-table-column>
              <el-table-column
                align='right'
                label='佣金分成'
                prop='brokerage_pay'
                sortable='custom'
                width='110'
              >
                <template slot-scope={row}>
                  <span>{{ moneyFormat(row.brokerage_pay) }}</span>
                </template>
              </el-table-column>
              <el-table-column
                align='right'
                label='其他应扣/补款'
                prop='other_pay'
                sortable='custom'
                width='110'
              >
                <template slot-scope={row}>
                  <span :style='`color: ${row.other_pay>=0?"#000000":"#ff003b"}`'>
                    {{ moneyFormat(row.other_pay) }}</span>
                </template>
              </el-table-column>
              <el-table-column
                align='right'
                label='承担的营销费用'
                prop='marketing_costs'
                sortable='custom'
                width='120'
              >
                <template slot-scope={row}>
                  <span>{{ moneyFormat(row.marketing_costs) }}</span>
                </template>
              </el-table-column>
              <el-table-column
                align='right'
                label='应付款合计'
                prop='due_total'
                sortable='custom'
                width='110'
              >
                <template slot-scope={row}>
                  <span>{{ moneyFormat(row.due_total) }}</span>
                </template>
              </el-table-column>
              <el-table-column
                align='center'
                label='结算方式'
                prop='settle_method'
                width='80'
                sortable='custom'
              >
                <template slot-scope='{row}'>
                  <el-tag :type="row.settle_method==='corporate'?'success':'warning'" effect='plain'
                          v-if='row.settle_method_text'>
                    {{ row.settle_method_text || '' }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column
                align='right'
                label='个税'
                prop='person_tax'
                sortable='custom'
              >
                <template slot-scope={row}>
                  <span>{{ moneyFormat(row.person_tax) }}</span>
                </template>
              </el-table-column>
              <el-table-column
                header-align='center'
                align='right'
                label='实付款'
                prop='actual_pay'
                sortable='custom'
                width='110'
              >
                <template slot-scope={row}>
                  <span>{{ moneyFormat(row.actual_pay) }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop='invoice_type'
                label='发票类型'
                align='center'
                header-align='center'>
                <template slot-scope='{row}'>
                  <span>{{ optionMaps['invoice_type'][row.invoice_type] || '' }}</span>
                </template>
              </el-table-column>
              <el-table-column
                prop='tax_point'
                label='票面税点'
                align='center'
                header-align='center'>
                <template slot-scope='{row}'>
                  <span class='rate'>{{ rateFormat(row.tax_point) }}</span>
                </template>
              </el-table-column>
              <el-table-column
                header-align='center'
                align='right'
                label='发票总额'
                prop='invoice_amount'
                sortable='custom'
                width='110'
              >
                <template slot-scope={row}>
                  <span v-if='row.invoice_amount'>{{ moneyFormat(row.invoice_amount) }}</span>
                </template>
              </el-table-column>
              <el-table-column
                align='center'
                label='扣（补款）备注'
                prop='deduct_remark'
                min-width='260'
              >
              </el-table-column>
              <el-table-column
                align='center'
                label='通知状态'
                prop='msg_status'
                width='100'
              >
                <template slot-scope='{row}'>
                  <el-tag :type='msgStatusEffectMap[row.msg_status]' effect='plain'
                          v-if='row.msg_status'>
                    {{ row.msg_status_text ?? row.msg_status }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column
                align='center'
                label='确认状态'
                prop='audit'
                width='80'
              >
                <template slot-scope='{row}'>
                  {{ formatAudit(row.audit)['text'] || '--' }}
                </template>
              </el-table-column>
              <el-table-column
                align='center'
                label='发票'
                title='是否开票'
                prop='need_invoice'
                width='80'
              >
                <template slot-scope='{row}'>
                  <el-tag :type="row.need_invoice=='Y'?'success':'warning'" effect='plain' v-if='row.need_invoice'>
                    {{ row.need_invoice_text || '' }}
                  </el-tag>
                </template>
              </el-table-column>
              <el-table-column
                align='center'
                label='申请付款时间'
                prop='apply_time'
                width='120'
              >
                <template slot-scope='{row}'>
                  <div v-if='row.apply_time && row.apply_time!=="0000-00-00 00:00:00"'>
                    {{ row.apply_time ? dateFormat(row.apply_time) : row.apply_time }}
                  </div>
                  <div v-else>
                    <el-link type='primary' @click='handleApply(row)' v-if='row.settle_method==="corporate"'>申请审批
                    </el-link>
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                align='center'
                label='发放时间'
                prop='payment_time'
                sortable='custom'
                width='120'
              >
                <template slot-scope='{row}'>
                  {{ row.payment_time ? dateFormat(row.payment_time, '{y}-{m}-{d} {h}:{i}') : row.payment_time }}
                </template>
              </el-table-column>
              <el-table-column
                align='center'
                label='分成函状态'
                prop='letter_status'
                min-width='100'
              >
              </el-table-column>
              <el-table-column
                align='center'
                label='备注'
                prop='remark'
                min-width='260'
              >
              </el-table-column>
              <el-table-column prop='order_total' label='订单数量' width='100' align='right'
                               header-align='center'></el-table-column>
              <el-table-column prop='order_amount_sum' label='订单总额' width='110' align='right' header-align='center'>
                <template slot-scope={row}>
                  <span v-if='row.order_amount_sum'>{{ moneyFormat(row.order_amount_sum) }}</span>
                </template>
              </el-table-column>
              <el-table-column
                align='center'
                label='红人标签'
                width='120'
              >
                <template slot-scope='{row}'>
                  <div v-if='row.tag_names'
                       style='display: flex;flex-direction: row;flex-wrap: wrap;gap: 1px;padding: 1px;justify-content: space-evenly;'>
                    <el-tag
                      v-for='item in row.tag_names'
                      :key='item'
                      type='warning'
                      effect='plain'>
                      {{ item }}
                    </el-tag>
                  </div>

                </template>
              </el-table-column>
              <el-table-column label='修改时间'
                               align='center'
                               prop='updated_at'
                               min-width='200'
                               sortable='custom'
              >
                <template slot-scope='{row}'>
                  <span :title='`创建时间：${row.created_at}`'> {{ row.updated_at || '-' }}</span>
                </template>
              </el-table-column>

              <el-table-column
                align='center'
                label='操作'
                width='180' fixed='right'>
                <template slot-scope='scope'>
                  <div class='flex-evenly'>
                    <el-link @click='handleEdit(scope.row)'
                             type='primary'
                             icon='el-icon-edit-outline'
                             v-if="userPermissions.indexOf('artist_divide_save') !== -1">编辑
                    </el-link>
                    <el-link @click='handleDetailClick(scope.row)'
                             type='primary'
                             icon='el-icon-info'
                             v-if="userPermissions.indexOf('artist_divide_item') !== -1">详情
                    </el-link>
                    <el-link @click='handleDelete(scope.row)'
                             type='danger'
                             icon='el-icon-close'
                             v-if="userPermissions.indexOf('artist_divide_save') !== -1&& extra.lock_status==='N'">
                      删除
                    </el-link>
                  </div>

                </template>
              </el-table-column>
            </el-table>

            <div style='display: flex;flex-direction: row;justify-content: space-between;gap: 10px'>
              <div style='font-size: 14px;font-weight: bolder;line-height: 52px '>
                选中<span style='color: #ff3176;font-style:italic;'> {{ selection.length }}</span> 条记录，合计：
                应付款：<span
                  style='color: #ff3176;font-style:italic;'>{{ moneyFormat(total.due_total) }}</span>
                元，实付款 <span style='color: #ff3176;font-style:italic;'> {{ moneyFormat(total.actual_pay) }}</span> 元
                &nbsp;
                &nbsp;
                <el-button @click='clearSelect' round plain>
                  清空选择
                </el-button>
              </div>
              <div>
                <Pagination
                  :limit.sync='searchCondition.page_size'
                  :page.sync='searchCondition.current_page'
                  :total='tablePagination.total'
                  @pagination='getList' />
              </div>
            </div>
          </div>


          <!--          <div style='display: none'>-->
          <!--            <div class='theme-border default-padding' style='width: 400px'>-->
          <!--              <RobotSend></RobotSend>-->
          <!--            </div>-->

          <!--          </div>-->
        </div>

        <!--        钉钉通知-->
        <DingTalkNotify :dataJson='JSON.stringify(dialogData)' @close='closefn'></DingTalkNotify>

        <!-- 新增佣金分成弹窗 -->
        <CreateEdit ref='refCreateEdit' @saved='getList'></CreateEdit>
        <!-- 同步页面 -->
        <SyncView ref='refSyncView'></SyncView>

        <!--      导入分成记录   -->
        <ImportArtistDivide :visible.sync='openImport' @imported='handleQuery' />
        <!--        导入订单明细-->
        <ImportArtistOrders :visible.sync='openImportOrders' @imported='handleQuery' />

        <NotifySend ref='refNotifySend'></NotifySend>

      </div>
    </PageHeaderLayout>
  </div>
</template>

<script>
import PageHeaderLayout from '@/layouts/PageHeaderLayout'
import { mapGetters } from 'vuex'
import { parseTime } from '@/utils/index.js'
import ImportArtistDivide from './components/ImportArtistDivide'
import CreateEdit from './components/CreateEdit.vue'
import ImportArtistOrders from '@/pages/artist_commission/components/ImportArtistOrders.vue'
import SyncView from '@/pages/artist_commission/components/SyncView.vue'
import { copyTextToClipboard } from '@/utils/sys/copy'
import RobotSend from '@/components/notify/RobotSend.vue'
import DingTalkNotify from '@/components/dingTalkNotify/dingTalkNotify.vue'
import NotifyHistory from '@/components/dingTalkNotify/NotifyHistory.vue'
import employeesDialog from '@/components/workflow/dialog/employeesDialog.vue'
import NotifySend from './components/NotifySend.vue'
import { exportArtistDivides, resetStatusArtistDivide, updateArtistDivideAgent } from '@/api/artist_divide'
import ExportBtn from '@/components/export/ExportBtn.vue'


export default {
  name: 'CommissionList',
  components: {
    ExportBtn,
    NotifySend,
    employeesDialog,
    NotifyHistory,
    DingTalkNotify,
    RobotSend,
    SyncView,
    ImportArtistOrders,
    CreateEdit,
    PageHeaderLayout,
    ImportArtistDivide
  },
  computed: {
    ...mapGetters(['userPermissions']),
    msgStatusEffectMap() {
      const map = {}
      this.msgStataMap.map((item) => {
        map[item.value] = item.type
      })
      return map
    },
    //锁定/解锁仅支持单个月份：区间开始与结束为同一个月时才有效
    lockMonth() {
      const rangYm = this.searchCondition.rangYm
      if (Array.isArray(rangYm) && rangYm.length === 2 && rangYm[0] && rangYm[0] === rangYm[1])
        return rangYm[0]

      return null
    }
  },
  data() {
    return {
      showMore: false,
      loading: false,
      //是否显示弹出层:导入框
      openImport: false,
      openImportOrders: false,
      //筛选条件缓存key
      pageSearchKey: 'page_search_key:artist_divide',
      file: [],
      //筛选data
      searchCondition: {
        artist_id: [],
        msg_status: [],
        audit: [],
        //月份区间查询：[开始月份, 结束月份]，格式 yyyy-MM ，默认选中：上个月 - 上个月
        rangYm: this.defaultMonthRange(),
        settle_method: null,
        invoice_type: null,
        need_invoice: null,
        nickname: '',
        status: null,
        letter_status: null,//双方已签、红人未签、未发起
        page_size: 15,
        current_page: 1
      },
      // 分成函状态
      letterStatusRange: ['双方已签', '红人未签', '未发起'],
      // 数组data
      tableData: [],
      stats: [],
      extra: {
        oa_domain: 'http://localhost:5173',
        lock_status: 'unknown'
      },
      //数组页码
      tablePagination: {
        total: 0,
        page_size: 15,
        offset: 0,
        current_page: 1
      },
      selection: [],
      ids: [],
      //状态筛选
      statusMap: [
        { text: '未申请', value: 1, type: 'warning' },
        { text: '已申请', value: 2, type: 'primary' },
        { text: '已打款', value: 3, type: 'success' }
      ],
      msgStataMap: [
        { text: '未通知', value: 1, type: '' },
        { text: '分成通知', value: 2, type: 'warning' },
        { text: '分成已读', value: 3, type: 'success' },
        { text: '打款通知', value: 4, type: 'warning' },
        { text: '打款已读', value: 5, type: 'success' }
      ],
      statusAuditSet: [
        // { text: '全部', value: 0 },
        { text: '待确认', value: 1 },
        // { text: '取消确认', value: 2 },
        { text: '分成确认', value: 3 },
        // { text: '审核未通过', value: 4 },
        // { text: '已审核', value: 5 },
        // { text: '审核关闭', value: 6 }
        { text: '打款确认', value: 7 }
      ],
      optionMaps: {
        settle_method: { 'corporate': '对公', 'private': '个人' },
        invoice_type: { 'normal': '普通发票', 'special': '专用发票' }
      },
      // rangYm: null,
      pickerOptions: {
        shortcuts: [{
          text: '本月',
          onClick(picker) {
            picker.$emit('pick', [new Date(), new Date()])
          }
        }, {
          text: '今年至今',
          onClick(picker) {
            const end = new Date()
            const start = new Date(new Date().getFullYear(), 0)
            picker.$emit('pick', [start, end])
          }
        }, {
          text: '最近六个月',
          onClick(picker) {
            const end = new Date()
            const start = new Date()
            start.setMonth(start.getMonth() - 6)
            picker.$emit('pick', [start, end])
          }
        }]
      },
      checkList: [],
      // , checkLists: [],
      dialogData: {
        dialogVisible: false,
        head: {
          id: '',
          type: ''
        },
        api: 'dingTalkNotifyartistDivide'
      },
      orderSort: { 'id': 'asc' },
      msgname: {},
      dialogVisible: false,
      notifyTypeMap: [
        { txt: '确认通知', value: 1 },
        { txt: '打款通知', value: 2 }
      ],
      isShowNotifyHistory: false,
      formData: {
        nickname: null,
        agent_name: null,
        agent_userid: null,
        notify_type: 1//1-确认通知
      },
      total: {
        actual_pay: 0,//实付款合计
        due_total: 0 //应付款合计
      },
      btnloading: false

    }
  },
  methods: {
    //默认查询的月份区间：上个月 - 上个月
    defaultMonthRange() {
      const date = new Date()
      //先归零到1号，避免月末（如3月31日）回退月份时溢出
      date.setDate(1)
      date.setMonth(date.getMonth() - 1)
      const month = `0${date.getMonth() + 1}`.slice(-2)
      const date_time = `${date.getFullYear()}-${month}`
      return [date_time, date_time]
    },
    handleLock() {
      if (!this.lockMonth) {
        this.msgWarn('锁定/解锁仅支持单个月份，请选择开始与结束相同的月份！！！')
        return false
      }
      this.$confirm(`此操作将『锁定』【${this.lockMonth}】红人分成记录, 是否继续?`, '锁定提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'success'
      }).then(async () => {
        await this.$api.lockArtistDivide(this.lockMonth)
        await this.msgSuccess('锁定：操作成功')
        await this.getList()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })

    },
    handleUnlock() {
      if (!this.lockMonth) {
        this.msgWarn('解锁仅支持单个月份，请选择开始与结束相同的月份！！！')
        return false
      }
      this.$confirm(`此操作将『解锁』【${this.lockMonth}】红人分成记录, 是否继续?`, '解锁提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        //
        await this.$api.unlockArtistDivide(this.lockMonth)
        await this.msgSuccess('解锁：操作成功')
        await this.getList()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消'
        })
      })
    },
    handleNotify(row) {
      if (this.$refs['refNotifySend'])
        this.$refs['refNotifySend'].open(row)
    },

    closefn(data) {
      this.dialogData = data
      this.getList()
    },
    formatAudit(val) {
      const obj = this.statusAuditSet.find(value => value.value == val)
      return obj
    },
    handleQuery() {
      this.tablePagination.current_page = 1
      this.searchCondition.current_page = 1
      this.getList()
    },
    getSummaries(param) {
      // eslint-disable-next-line no-unused-vars
      const { columns, data } = param
      const sums = []
      columns.forEach((column, index) => {
        if (index === 4) {
          sums[index] = '合计'
          return
        }

        if (this.stats[column.property])
          sums[index] = this.moneyFormat(this.stats[column.property])
      })

      return sums
    },

    handleRowClick(row, column) {
      if (column.property) {
        const text = row[column.property] || ''
        copyTextToClipboard(text)
        this.$notify.success(`复制成功`)
      }
    },
    dateFormat(dateStr, cFormat) {
      if (!dateStr || dateStr === '0000-00-00 00:00:00')
        return ''

      return parseTime(dateStr, cFormat || '{y}-{m}-{d}')
    },
    handleApply(row) {
      const t = new Date().getTime()
      // let currHost = window.location.host
      const oa_domain = this.extra.oa_domain
      const url = `${oa_domain}/createKolApproval/add?t=${t}&sid=${row.id}`

      if (this.$utils.isDingTalk()) {
        window.open(url, '_self')
      } else {
        window.open(url, '_blank')
      }
    },
    handleDelete(row) {
      this.$confirm(`此操作将永久删除该数据(${row.date_time}/${row.nickname}), 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await this.$api.deleteArtistDivide(row.id)
        await this.getList()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    handleBatchDelete() {
      this.$confirm(`确认删除勾选的[${this.ids.length}]条数据, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await this.$api.deleteArtistDivide(this.ids)
        await this.getList()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })

    },
    handleBatchNotify() {
      this.$confirm(`确认通知勾选的[${this.ids.length}]条红人分成记录的经纪人（钉钉用户信息已同步到系统）确认分成信息, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const data = await this.$api.batchAssistantNotifyByIds(this.ids)
        if (data)
          await this.getList()

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })

    },
    handleSync() {
      if (this.$refs['refSyncView'])
        this.$refs['refSyncView'].open()
    },
    handleAdd() {
      if (this.$refs['refCreateEdit'])
        this.$refs['refCreateEdit'].add()
    },
    handleEdit(row) {
      if (this.$refs['refCreateEdit'])
        this.$refs['refCreateEdit'].edit(row)
    },
    clearSelect() {
      this.$refs.multipleTable.clearSelection()
    },
    handleDetailClick(row) {
      //操作按钮
      //查看
      this.$router.push({
        name: 'artist_commission_detail',
        params: { id: row.id }
      })
    },

    handleSelectionChange(val) {
      this.selection = val
      this.ids = this.selection.map((item) => {
        return item.id
      })
      this.total.actual_pay = 0
      this.total.due_total = 0
      this.selection.forEach((item) => {
        this.total.actual_pay += Number(item.actual_pay)
        this.total.due_total += Number(item.due_total)
      })
    },
    async auditSubmit(data) {
      const id = await this.$api.artistAudit(data)
      if (id) {
        this.$notify.success('成功')
        await this.getList()
      } else this.$notify.error('未知失败')
    },

    handleSearchCondition() {
      const condition = {}
      Object.keys(this.searchCondition).forEach((field) => {
        // 月份区间查询条件单独处理
        if (field === 'rangYm') return
        if (this.searchCondition[field] != null) {
          if (Object.prototype.toString.call(this.searchCondition[field]) === '[object Array]') {
            if (this.searchCondition[field].length > 0) {
              condition[field] = this.searchCondition[field]
            }
          } else {
            // 字符串长度大于0
            if (this.searchCondition[field])
              condition[field] = this.searchCondition[field]
          }
        }
      })

      // 月份区间查询：转为 start_month / end_month
      const rangYm = Array.isArray(this.searchCondition.rangYm) ? this.searchCondition.rangYm : []
      if (rangYm.length === 2 && rangYm[0] && rangYm[1]) {
        condition.start_month = rangYm[0]
        condition.end_month = rangYm[1]
      }

      // 分页 +排序
      Object.assign(condition, this.pageData, { order: this.orderSort }, {
        page_size: this.searchCondition.page_size,
        current_page: this.searchCondition.current_page
      })
      //缓存筛选条件，刷新后可以继续使用
      sessionStorage.setItem(this.pageSearchKey, JSON.stringify(condition))
      return condition
    },

    changeTableSort({ prop, order }) {
      const orderSort = {}
      if (order) {
        orderSort[prop] = order === 'descending' ? 'desc' : 'asc'
      }
      this.orderSort = orderSort
      this.getList()
    },
    async getList() {
      this.loading = true
      setTimeout(() => {
        this.loading = false
      }, 500)

      const searchCondition = this.handleSearchCondition()

      // Object.assign(searchCondition, {
      //   page_size: this.tablePagination.page_size,
      //   current_page: this.tablePagination.current_page
      // })
      const { list, pages, stats, extra } = await this.$api.getArtistDivideList(searchCondition)
      if (extra) {
        this.extra = { ...extra }
      }
      if (stats) {
        this.stats = { ...stats }
      }
      this.$nextTick(() => {
        this.tableData = list

        this.searchCondition.current_page = pages.current_page || 1
        this.searchCondition.page_size = pages.page_size || 15
        this.tablePagination.offset = pages.offset || 0
        this.tablePagination.total = pages.total
        this.loading = false
      })
      //缓存筛选条件，刷新后可以继续使用
      // sessionStorage.setItem(this.pageSearchKey, JSON.stringify(this.searchCondition))
    },
    //批量样式居中
    headClass() {
      return 'text-align:center'
    },
    moneyFormat(value) {
      return this.$utils.numberFormat(value, 2, '.', ',', 'round')
    },
    rateFormat(num) {
      return this.$utils.numberFormat(num, 0)
    },
    //导出表格
    async handleExport() {
      try {
        const searchCondition = this.handleSearchCondition()
        const response = await exportArtistDivides(searchCondition)
        const name = `红人分成表`

        this.$refs.refLogisticSubscribeExport.exportSaveXlsx(response, name)
      } catch (e) {
        this.$message.warning('导出异常，请联系管理员')
        this.$refs.refLogisticSubscribeExport.hideLoading()
      }
    },
    handleChangeAgent(data) {
      if (data.id && data.agent_name && data.agent_userid)
        updateArtistDivideAgent(data)
    },
    handleBatchReset() {
      this.$confirm(`确认重置勾选的[${this.ids.length}]条记录的通知状态和确认状态, 是否继续?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await resetStatusArtistDivide(this.ids)
        await this.getList()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })

    }
  },
  watch: {
    '$route.matched': {
      immediate: true,
      handler(n) {
        if (n.length === 2) {
          if (sessionStorage.getItem(this.pageSearchKey)) {
            const searchCondition = JSON.parse(sessionStorage.getItem(this.pageSearchKey))
            if (searchCondition) {
              this.orderSort = { ...searchCondition.order }
              delete searchCondition.order
              // 月份区间查询条件回填
              const startMonth = searchCondition.start_month || null
              const endMonth = searchCondition.end_month || null
              delete searchCondition.start_month
              delete searchCondition.end_month
              delete searchCondition.date_time
              // 保留 searchCondition 已有字段（rangYm 等），避免响应式丢失
              this.searchCondition = { ...this.searchCondition, ...searchCondition }
              // 无缓存月份条件时，保持默认：上个月 - 上个月
              this.searchCondition.rangYm = (startMonth && endMonth) ? [startMonth, endMonth] : this.defaultMonthRange()
              // this.tablePagination = searchCondition.order
            }
          } else {
            this.searchCondition.rangYm = this.defaultMonthRange()
          }

          this.getList()
        }
      }
    }

  }
}
</script>
<style scoped>

/**
RGB 是屏幕显示常用的颜色模型，标准橙色的 RGB 值为 (255, 165, 0)，十六进制代码为 #FFA500。其他常见橙色变体包括：‌
橙红：RGB(255, 51, 0) 或 #FF3300。‌
正橙色：RGB(255, 128, 0) 或 #FF8000。‌
橙黄：RGB(255, 153, 0) 或 #FF9900。‌
 */
.default-orange {
  color: #FF8000;
}
</style>
